<form [formGroup] = "contactForm">

  <div id="updatemodal" style="display:none; position:fixed; z-index:1000; left:0; top:0; width:100%; height:100%; overflow:auto; background-color:rgba(0,0,0,0.75);">
    <div style="background-color: #ffffff;
    margin: 25% auto;
    padding: 2em;
    border: 1px solid #888;
    width: 80%;
    max-width: 300px;
    border-radius: 1em;">
      <p style="color: #424242;font-weight: 600;">Would you like to update the contact info on all projected and scheduled jobs with this contact? <p>
      <button style="border: 0;margin-right: 2em;background: #8cc63f;color: white;width: 4em;" (click)="handleModalResponse(true)">Yes</button>
      <button style="background: #ffffff;color: #424242;width: 4em;border: 1px solid #d8d8d8;" (click)="handleModalResponse(false)">No</button>
    </div>
  </div>




<h1 *ngIf ="mode ==1" mat-dialog-title> Editing {{data.name}}</h1>
<h1 *ngIf ="mode ==2" mat-dialog-title> Add Contact </h1>

<div mat-dialog-content>



  <mat-form-field style="width:90%; padding-top:20px;">
      <mat-label>Name:</mat-label>
      <input matInput formControlName = "name" (keyup)="onNameInputChange($event)">
    </mat-form-field>

    <div *ngIf="duplicateWarningResults.length > 0"
     style="color: red; font-size: 13px; margin: -10px 0 15px 5px;">
  <strong>Similar contacts found:</strong>
  <div *ngFor="let c of duplicateWarningResults">
    • {{ c.name }} <span *ngIf="c.email">({{ c.email }})</span>
  </div>
</div>

    <mat-form-field style="width:90%">
        <mat-label>Phone:</mat-label>
        <input matInput formControlName = "phone">
      </mat-form-field>


<div *ngIf = "mode == 2">
  <mat-checkbox labelPosition="before" (change)="homeownerToggle()">Homeowner?</mat-checkbox>
</div>



  <div *ngIf="homeowner == false">
      <mat-form-field style="width:90%">
          <mat-label>Customer: {{data.customer_name}}</mat-label>
          <input  #custname matInput formControlName = "customer_name" [matAutocomplete] = "custauto">
      </mat-form-field>

<!-- we need to not show the autocomplete when not in use-->
    <mat-autocomplete #custauto = "matAutocomplete" (optionSelected) = "onSelectCustomer($event.option.value)" [displayWith]="displayFunction">
      <mat-option *ngFor="let customer of (customer$ | async)" [value]="customer">
        <span>{{ customer.customer_name }}</span>
      </mat-option>
    </mat-autocomplete>
  </div>

  <div *ngIf="homeowner == true">
    <p>Enter new customer name below: </p>
    <mat-form-field style="width:90%">
      <mat-label>Customer Name (Homeowner):</mat-label>
      <input matInput formControlName = "customer_homeowner">
    </mat-form-field>
  </div>


    <mat-form-field style="width:90%">
        <mat-label>Email:</mat-label>
        <input matInput formControlName = "email">
      </mat-form-field>

    <mat-form-field style="width:90%">
        <mat-label>Notes: </mat-label>
        <textarea matInput formControlName = "note"></textarea>
    </mat-form-field>
  <br>

  <div>
      <mat-label>Inactive?:  </mat-label>
      <mat-checkbox formControlName = "inactivecontact"></mat-checkbox>
  </div>
  <div>
    <button style="background:#424242;color:white;margin-top: 2em; " mat-button (click)="showModal()">Update Scheduled/Projected </button>
  </div>

  <div *ngIf="mode == 1" [formGroup]="prefsForm"
       style="margin-top:1.5em; border-top:1px solid #e0e0e0; padding-top:1em;">
    <mat-label style="font-weight:600; display:block; margin-bottom:8px;">Text Message Preferences</mat-label>
    <div><mat-checkbox formControlName="confirmations">Confirmations</mat-checkbox></div>
    <div><mat-checkbox formControlName="on_our_way">"On our way" texts (rater button)</mat-checkbox></div>
    <p style="font-size:12px; color:#777; margin-top:10px;">
      Text opt-out (STOP): <strong>{{ data.textoptout ? 'ON' : 'OFF' }}</strong>.
      STOP via text overrides all preferences.
    </p>
  </div>
</div>

<div mat-dialog-actions>
  <button mat-button (click)="onNoClick()">Close</button>
  <button *ngIf ="mode ==1" mat-button  (click)="save()" [mat-dialog-close]="data" cdkFocusInitial>Save</button>
  <button *ngIf ="mode ==2" mat-button  (click)="add()"  [mat-dialog-close]="data" cdkFocusInitial>Add Contact</button>
  
</div>
</form>
